// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".orders-container {\n    margin-top: 2rem;\n}\n\n.orders-table, .orders-table td, .orders-table th  {\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
